import { alpha, ListItem, ListItemButton, Tooltip } from "@mui/material";
import { createLink } from "@tanstack/react-router";
import type { ReactNode } from "react";
import type { NavItemTarget } from "../NavMenu/types";

/** A list button that is a router link: one anchor, one tab stop. */
const LinkListItemButton = createLink(ListItemButton);

/** The width and height of a rail item, and so of the rail's column. */
export const RAIL_ITEM_SIZE = 48;

/**
 * A 48px icon button of the collapsed sidebar (R-2295). Hover and keyboard
 * focus show its name in a tooltip on the right; a product without a plan
 * adds "Inactive". The item that holds the current page is selected. Every
 * item opens a page, and the rail stays collapsed.
 *
 * The button is the link itself, so a keyboard reaches each item in one Tab.
 */
export default function RailItem({
  title,
  inactive = false,
  icon,
  selected,
  target,
  testId,
}: {
  title: string;
  /** A product without a plan. */
  inactive?: boolean;
  icon: ReactNode;
  selected: boolean;
  target: NavItemTarget;
  testId?: string;
}) {
  const tooltip = inactive ? (
    <>
      {title}
      <span
        style={{
          marginLeft: 8,
          // 60% white, as the design's Rail Tooltip has it.
          color: alpha("#fff", 0.6),
        }}
      >
        Inactive
      </span>
    </>
  ) : (
    title
  );

  return (
    <Tooltip title={tooltip} placement="right" arrow>
      <ListItem disablePadding sx={{ width: RAIL_ITEM_SIZE }}>
        <LinkListItemButton
          to={target.to}
          params={target.params}
          selected={selected}
          aria-label={inactive ? `${title}, inactive` : title}
          data-testid={testId}
          sx={{
            width: RAIL_ITEM_SIZE,
            height: RAIL_ITEM_SIZE,
            p: 0,
            justifyContent: "center",
            borderRadius: 2,
          }}
        >
          {icon}
        </LinkListItemButton>
      </ListItem>
    </Tooltip>
  );
}
